import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Profile from "../assets/images/BottomTab/Profile.svg";
import Notification from "../assets/images/BottomTab/Notification.svg";
// import Chat from '../assets/images/BottomTab/Chat.png'
import Favorites from "../assets/images/BottomTab/favorites.svg";
import Home from "../assets/images/BottomTab/Vector.svg";
import Libas from "../assets/images/BottomTab/Libas.svg";
import { UserContext } from "../context/user.context";
import SignIn from "./SignIn/SignIn";
import SignUp from "./SignUp/SignUp";
import NotificationModal from "./Modals/NotificationModal";
import { useSelector } from "react-redux";

function TabBottom() {
  const { currentUser } = useContext(UserContext);
  const [signIn, setSignIn] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const { users, notifications } = useSelector((store) => store.allproducts);
  //  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const handleClick = (detail) => {
    navigate(detail.link);
  };
  const items = [
    {
      id: "1",
      img: Home,
      link: "/",
      txt: "Home",
      class: "img2-tabBottom",
    },
    {
      id: "2",
      img: Favorites,
      link: "/wishlist",
      txt: "Favorites",
      class: "img2-tabBottom",
    },
    {
      id: "3",
      img: Libas,
      link: "/how-to-sell",
      txt: "Sell",
      class: "img2-tabBottom",
    },
    {
      id: "4",
      img: Notification,
      link: "/",
      txt: "Notifications",
      class: "img2-tabBottom",
    },
    {
      id: "5",
      img: Profile,
      link: !currentUser ? "/" : `/profile/${currentUser.uid}`,
      txt: "Profile",
      class: "img2-tabBottom",
    },
  ];
  return (
    <>
      {showNotification && (
        <NotificationModal
          show={showNotification}
          setShow={setShowNotification}
          users={users}
          notifications={notifications}
          currentUser={currentUser}
        />
      )}

      {signUp && (
        <SignUp
          signUp={signUp}
          setSignUp={setSignUp}
          handleSignIn={setSignIn}
        />
      )}
      {signIn && (
        <SignIn
          signIn={signIn}
          handleSignIn={setSignIn}
          handleSignUp={setSignUp}
        />
      )}

      <div
        className="row d-md-none tab-bottom fixed-bottom mx-0 px-0 shadow-box "
        style={{ paddingRight: "0px", paddingLeft: "0px" }}
      >
        <div
          className="col-12 text-center"
          style={{ paddingRight: "0px", paddingLeft: "0px" }}
        >
          <div className=" justify-content-between d-flex bg-tabBottom align-items-center px-4">
            {items.map(
              (detail) => (
                <div
                  className="text-decoration"
                  key={detail.id}
                  onClick={() =>
                    !currentUser &&
                    (detail.id == "2" || detail.id == "4" || detail.id == "5")
                      ? setSignIn(true)
                      : detail.id == 4
                      ? setShowNotification(true)
                      : handleClick(detail)
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <img
                      src={detail.img}
                      alt="brand-img"
                      className={detail.class}
                    />
                    <div className="text-center txt-tabBottom pt-2">
                      {detail.txt}
                    </div>
                  </div>
                </div>
              )
              //  <Link to={detail.link} className="text-decoration  "  key={detail.id}>

              //            <div  >

              //                <img src={detail.img} alt="brand-img" className={detail.class} />

              //              <div className="text-center txt-tabBottom pt-2">{detail.txt}</div>
              //              </div>

              //             </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default TabBottom;
